import React from "react";
import * as Auth from "../../domains/AuthDomain";
import { getURLVal } from "../../domains/URLDomain";
import config from "config";
import ReactGA from "react-ga";
import standardizeEmail from "../../common/standardizeEmail";
import moment from "moment";


class CoachGiftCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPlanIdx: null,
      isAuthed: false,
      userId: "",
      email: "",
      giftEmail: "",
      password: "",
      firstName: "",
      lastName: "",
      emailConsent: false,
      showSignup: false,
      showLogin: false,
      activeSection: 0, //values are 0-2
      validationErrors: {},
      loginErrorDesc: "",
      coachOrgId: props.route.coachOrgId,
      extraPlan: props.route.extraPlan,
      paymentLoading: false,
      paymentError: "",
      benefitsShowing: false,
      shouldSkipAuth: this.shouldSkipAuth(),
      paymentErr: null,
      agreementsChecked: true,
      emailError: false,
      giftEmailError: false,
      sendDate: moment().format("YYYY-MM-DDTHH:mm"),
      timeInMs: moment().valueOf(),
    };

    this.paymentErrors = {
      noPlanSelected: "Please select a plan on Step 1",
      missingEmail:
        "Please ensure both your and the gift recipient's email is entered",
      missingDate: "Please select a time to email the gift to your recipient",
    };
  }

  componentDidMount = () => {
    this.props.actions.paymentActions.fetchProductInfo(this.state.coachOrgId);
    this.props.actions.paymentActions.fetchOnboardingOptions(
      this.state.coachOrgId
    );

    if (this.props.route.tabTitle) {
      document.title = this.props.route.tabTitle;
    }

    this.initAnalytics();
  };

  initAnalytics = async () => {
    const { coachOrgId } = this.state;

    let coachName = this.props.coachName;
    if (!coachName) {
      coachName = await this.props.actions.analyticsActions.fetchCoachName(
        coachOrgId
      );
    }
  };

  componentWillReceiveProps = (nextProps) => {
    if (
      nextProps.route.extraPlan &&
      nextProps.extraPlanOptions &&
      nextProps.extraPlanOptions !== this.props.extraPlanOptions &&
      nextProps.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      if (nextProps.extraPlanOptions.get(nextProps.route.extraPlan).size < 2) {
        this.setState({ selectedPlanIdx: 0 }, this.calculateActiveSection);
      }
    } else {
      if (
        nextProps.planOptions !== this.props.planOptions &&
        nextProps.planOptions.size < 2
      ) {
        this.setState({ selectedPlanIdx: 0 }, this.calculateActiveSection);
      }
    }

    if (nextProps.siteCheckout) {
      const benefitsShowing =
        nextProps.siteCheckout.get("benefits") &&
        nextProps.siteCheckout.get("benefits").size > 0;
      this.setState({ benefitsShowing });
    }
  };

  shouldSkipAuth = () => {
    const uid = getURLVal("uid");
    const source = getURLVal("source");
    const email = getURLVal("email");

    if (uid && email && source === "app") {
      return true;
    } else {
      return false;
    }
  };

  getPriceDisplay = (price) => {
    const hasCents = price % 100;
    const renderPrice = price / 100;
    const with2Decs = renderPrice.toFixed(2);
    return hasCents ? with2Decs : renderPrice;
  };

  calculateActiveSection = () => {
    if (!(this.state.selectedPlanIdx || this.state.selectedPlanIdx === 0)) {
      this.setState({ activeSection: 0 });
    } else if (!this.state.isAuthed) {
      this.setState({ activeSection: 1 });
    } else {
      this.setState({ activeSection: 2 });
    }
  };

  getGAPlanLabel = (planIdx) => {
    let planOptions = null;
    if (
      this.props.route.extraPlan &&
      this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }

    if (!planOptions) {
      return null;
    }

    const planSelected = planOptions.get(planIdx);
    if (!planSelected) {
      return null;
    }

    const planJS = planSelected.toJS();
    const { time_unit, time_val, price } = planJS;

    let label = null;
    if (time_unit && time_val) {
      label = `${time_val}_${time_unit}`;
    } else {
      label = this.getPriceDisplay(price);
    }

    label += "_coachOrgId=" + this.state.coachOrgId;

    return label;
  };

  getPriceLabel = (planIdx) => {
    let planOptions = null;
    if (
      this.props.route.extraPlan &&
      this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }

    if (!planOptions) {
      return null;
    }

    const planSelected = planOptions.get(planIdx);
    if (!planSelected) {
      return null;
    }

    const planJS = planSelected.toJS();
    const { price } = planJS;

    let label = null;

    if (price) {
      label = price;
    }

    return label;
  };

  //BUTTON FUNCTIONS
  selectPlan = (planIdx) => {
    this.setState({ selectedPlanIdx: planIdx }, () => {
      this.calculateActiveSection();
    });

    if (this.state.paymentError === this.paymentErrors.noPlanSelected) {
      this.setState({
        paymentError: "",
      });
    }

    const label = this.getGAPlanLabel(planIdx);

    ReactGA.event({
      category: "Purchase",
      action: "Selected Plan",
      label,
    });
  };

  prepInitStripeCheckoutArgs = () => {
    const { selectedPlanIdx } = this.state;

    let planOptions = null;
    if (
      this.props.route.extraPlan &&
      this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }
    const planSelected = planOptions.get(selectedPlanIdx);

    let stripeCouponId = null;
    let discountedPrice = null;
    const minuteBuffer = 60;
    const unixBuffer = minuteBuffer * 60 * 1000; //Minutes X 60 seconds x 1000 milliseconds
    const activePromo = this.findValidPromo(planSelected, unixBuffer); //adds buffer to expiration date so people who take a while to checkout dont lose the promo when clicking pay
    if (activePromo) {
      stripeCouponId = activePromo.get("stripeCouponId");
      discountedPrice = activePromo.get("buttonPrice");
    }

    let initStripeCheckoutArgs = {
      planSelected: planSelected.toJS(),
      stripeCouponId,
      coachOrgStripePubKey: this.props.stripePubKey,
      coachOrgId: this.state.coachOrgId,
      successURL: this.getCheckoutSuccessUrl(),
      discountedPrice,
      giftEmail: this.state.giftEmail,
      isGiftPurchase: true,
      sendGiftAt: this.state.timeInMs,
      coachLogo: this.props.logo,
      productName: this.props.productName,
    };

    if (this.props.route.requireBillingAddress) {
      initStripeCheckoutArgs.requireBillingAddress = true;
    }

    // if (this.props.route.enableRewardful) {
    //   const rewardfulId = getURLVal("refid");
    //   initStripeCheckoutArgs.rewardfulId = rewardfulId;
    // }

    // if (this.state.shouldSkipAuth) {
    //   initStripeCheckoutArgs = Object.assign(initStripeCheckoutArgs, {
    //     mobileRequestId: getURLVal("uid"), //if user came from mobile app, data is pre-stored in db
    //   });
    // } else {
    initStripeCheckoutArgs = Object.assign(initStripeCheckoutArgs, {
      // userId: this.state.userId,
      firstname: this.state.firstName,
      lastname: this.state.lastName,
      email: standardizeEmail(this.state.email),
    });
    // }

    //ap stands for ad payer
    // if (getURLVal("ap") === "trybe") {
    //   initStripeCheckoutArgs.ap = "trybe";
    // }

    return initStripeCheckoutArgs;
  };

  convertTimeToMs = (timeString) => {
    //In format 2022-12-11T21:52
    const convertedTime = moment(timeString).valueOf()
    return convertedTime
  }

  onClickPay = () => {
    const { selectedPlanIdx, sendDate } = this.state;
    this.setState({ paymentError: false });

    if (!selectedPlanIdx && selectedPlanIdx !== 0) {
      this.setState({
        paymentError: this.paymentErrors.noPlanSelected,
      });
    } else if (!this.state.email || !this.state.giftEmail) {
      this.setState({
        paymentError: this.paymentErrors.missingEmail,
      });
    } else if (!this.state.sendDate) {
      this.setState({
        paymentError: this.paymentErrors.missingDate,
      });
    } else {
      const emailValid = Auth.checkEmailValid(this.state.email);
      const giftEmailValid = Auth.checkEmailValid(this.state.giftEmail);

      this.setState({
        emailError: !emailValid,
        giftEmailError: !giftEmailValid,
      });

      if (emailValid && giftEmailValid) {
        this.handlePayment()
      }
    }
  };

  handlePayment = async () => {
    this.setState({ paymentLoading: true });

    //ADD CHECK THAT EMAIL IS VALID

    const initStripeCheckoutArgs = this.prepInitStripeCheckoutArgs();

    const { success, error } =
      await this.props.actions.paymentActions.initStripeCheckout(
        initStripeCheckoutArgs
      );

    if (success) {
      window.location = success; //success val is Stripe Checkout seshion link
    } else {
      this.setState({
        paymentLoading: false,
        paymentError: error,
      });
    }
  };

  onClickAgreementsCheck = () => {
    this.setState({
      agreementsChecked: !this.state.agreementsChecked,
    });
  };

  onClickApp = () => {
    if (this.props.siteCheckout && this.props.siteCheckout.get("deepLink")) {
      window.open(this.props.siteCheckout.get("deepLink"), "_blank");
    }
  };

  //RENDER FUNCTIONS
  renderLogo = (isForSurvey) => {
    if (isForSurvey) {
      return (
        <div className="survey-logo-container">
          <img className="survey-logo-img" src={this.props.logo} />
        </div>
      );
    }

    return (
      <div className="creator-logo-container">
        <img className="logo-img" src={this.props.logo} />
      </div>
    );
  };

  renderPlanTopLargePromo = (plan) => {
    const origPrice = plan.get("price");
    const currency = plan.get("currency") || "USD";
    const promoText = this.getPlanPromoText(plan);
    let currSymbol = "$";
    if (currency === "EUR") {
      currSymbol = "€";
    }

    const renderPrice = this.getPriceDisplay(origPrice);

    //CANNOT BE USED WITH PROMO / STRIPE CHECKOUT 1

    const billingInterval = this.getBillingIntervalText(plan);
    return (
      <div className="option-text">
        <div className="top-text">{promoText}</div>
        <div className="primary-text-container">
          <div className="option-subtext">
            {currSymbol}
            {renderPrice}&nbsp;{currency}
            &nbsp;{billingInterval}
          </div>
        </div>
      </div>
    );
  };

  renderPlanTop = (plan) => {
    const origPrice = plan.get("price");
    const currency = plan.get("currency") || "USD";
    let currSymbol = "$";
    if (currency === "EUR") {
      currSymbol = "€";
    }

    const activePromo = this.findValidPromo(plan);
    const promoText = this.getPlanPromoText(plan, activePromo);

    //getPriceDisplay function determines how many digits past decimal to show
    const renderOrigPrice = this.getPriceDisplay(origPrice);

    const billingInterval = this.getBillingIntervalText(plan);
    //if plan has valid promo
    if (activePromo) {
      const promoPrice = activePromo.get("buttonPrice");
      // const promoInterval = activePromo.get("buttonIntervalText");
      const renderPromoPrice = this.getPriceDisplay(promoPrice);

      return (
        <div className="option-text">
          <div className="primary-text-container">
            <div className="strike-thru-container">
              <div className="top-text">${renderOrigPrice}</div>
              <div className="strike-thru-abs"></div>
            </div>
            <div className="top-text">
              &nbsp;{currSymbol}
              {renderPromoPrice}&nbsp;{currency}
            </div>
            <div className="billing-cycle-text">&nbsp;{billingInterval}</div>
          </div>
          {/* <div className="option-subtext">{promoText}</div> */}
        </div>
      );
    }

    return (
      <div className="option-text">
        <div className="primary-text-container">
          <div className="top-text">
            {currSymbol}
            {renderOrigPrice}&nbsp;{currency}
          </div>
          <div className="billing-cycle-text">&nbsp;{billingInterval}</div>
        </div>
        {/* <div className="option-subtext">{promoText}</div> */}
      </div>
    );
  };

  // getPlanTopText = (plan) => {
  //   let result, price;
  //   const defaultPrice = plan.get('price') / 100;

  //   if(plan.getIn(['promo', 'buttonPrice'])){
  //     price = plan.getIn(['promo', 'buttonPrice']) / 100;
  //   } else {
  //     price = defaultPrice;
  //   }

  //   return `$${price} USD`;
  // }

  getPlanPromoText = (plan, activePromo = false) => {
    let result;
    const defaultPromoText = plan.get("promoText");

    if (activePromo) {
      const runningPromoText = activePromo.get("buttonBottomText");
      result = runningPromoText || defaultPromoText;
    } else {
      result = plan.get("promoText");
    }

    return result;
  };

  getBillingIntervalText = (plan) => {
    const billing_interval = plan.get("time_val");
    const interval_unit = plan.get("time_unit");
    const paymentType = plan.get("paymentType");

    if (paymentType && paymentType === "one-time") {
      return "billed one-time";
    }

    if (billing_interval > 1) {
      return `for ${billing_interval} ${interval_unit}s of access`;
    } else {
      return `for ${billing_interval} ${interval_unit} of access`;
    }
  };

  renderPlanOptions = () => {
    const largePromoText = this.props.siteCheckout
      ? this.props.siteCheckout.get("largePromoText")
      : false;

    let planOptions = null;
    if (
      this.props.route.extraPlan &&
      this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }

    if (planOptions) {
      const optionsToRender = planOptions.map((item, idx) => {
        if (!item) return null;

        const optionJSX = (
          <div
            className="option"
            key={idx}
            onClick={() => this.selectPlan(idx)}
          >
            {largePromoText === true
              ? this.renderPlanTopLargePromo(item)
              : this.renderPlanTop(item)}
          </div>
        );

        if (idx !== 0) {
          //render with separator on top if more than 1 option
          return [<div className="separator"></div>, optionJSX];
        } else {
          //render first  or solo option with no separator on top
          return optionJSX;
        }
      });

      return optionsToRender;
    } else {
      return null;
    }
  };

  renderSelectedPlan = () => {
    const largePromoText = this.props.siteCheckout
      ? this.props.siteCheckout.get("largePromoText")
      : false;
    let planOptions = null;
    if (
      this.props.route.extraPlan &&
      this.props.extraPlanOptions &&
      this.props.extraPlanOptions.get(this.props.route.extraPlan)
    ) {
      planOptions = this.props.extraPlanOptions.get(this.props.route.extraPlan);
    } else {
      planOptions = this.props.planOptions;
    }
    const { selectedPlanIdx } = this.state;
    const selectedPlan = planOptions.get(selectedPlanIdx);
    const planResetVal = planOptions.size > 1 ? null : 0;

    const optionJSX = (
      <div
        className="option option-selected"
        onClick={() => this.selectPlan(planResetVal)}
      >
        {largePromoText === true
          ? this.renderPlanTopLargePromo(selectedPlan)
          : this.renderPlanTop(selectedPlan)}
        {planResetVal === 0 ? null : <div className="down-arrow" />}
      </div>
    );

    return optionJSX;
  };

  renderAccountSection = () => {
    const minDate = moment().format("YYYY-MM-DDTHH:mm");
    const maxDate = moment().add(3, "months").format("YYYY-MM-DDTHH:mm");

    return [
      <div className="account-subcontainer">
        <input
          type="text"
          className="account-input"
          placeholder="Your E-mail"
          id="purchaser-email"
          maxLength="254"
          onChange={(event) => {
            this.setState({ email: event.target.value });
          }}
          value={this.state.email}
        />
      </div>,
      <div className="separator-width">{this.renderSeparator()}</div>,
      <div className="account-subcontainer">
        <input
          type="text"
          className="account-input"
          placeholder="Recipient E-mail"
          id="gift-email"
          maxLength="254"
          onChange={(event) => {
            this.setState({ giftEmail: event.target.value });
          }}
          value={this.state.giftEmail}
        />
      </div>,
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        width: '85%',
        marginTop: 12,
      }}>
        <div style={{fontSize: 18, fontWeight: 500}}>Select a time to email recipient</div>
        <input
          type="datetime-local"
          id="send-date"
          name="send-date"
          value={this.state.sendDate}
          onChange={(event) => {
            const newTime = event.target.value;
            if(newTime){
              const convertedTime = this.convertTimeToMs(newTime)
              this.setState({ sendDate: newTime, timeInMs: convertedTime });
            } else {
              this.setState({ sendDate: newTime, timeInMs: moment().valueOf() });
            }
          }}
          min={minDate}
          max={maxDate}
        />
      </div>,
    ];
  };

  renderSeparator = () => {
    return (
      <div
        className="separator-container"
        style={{ marginTop: 6, marginBottom: 6 }}
      >
        {/* <div className="half-horiz-line" />
        <div className="or-text">AND</div>
        <div className="half-horiz-line" /> */}
      </div>
    );
  };

  goToForgotPassword = () => {
    const forgotURL = `/forgotpassword`;
    this.props.history.push({
      pathname: forgotURL,
      state: { allowBack: true },
    });
  };

  renderErrors = () => {
    const emailErrorText = `Invalid purchaser email address`;
    const giftEmailErrorText = `Invalid recipient email address`;

    return (
      <div className="login-errors">
        <div className="error-text">
          {this.state.emailError ? emailErrorText : null}
        </div>
        <div className="error-text">
          {this.state.giftEmailError ? giftEmailErrorText : null}
        </div>
      </div>
    );
  };

  renderPayButton = () => {
    const { paymentLoading } = this.state;
    const text = "Pay";
    const payText = <div className="pay-button-text">{text}</div>;
    const loader = <div className="loader" />;

    return (
      <button type="button" className="pay-button" onClick={this.onClickPay}>
        {paymentLoading ? loader : payText}
      </button>
    );
  };

  renderPaymentError = () => {
    const paymentError = this.state.paymentError;
    if (!paymentError || paymentError === "") return null;

    return (
      <div className="payment-errors">
        <div className="error-text"> {paymentError} </div>
      </div>
    );
  };

  renderHeroText = () => {
    if (!this.props.productName) {
      return null;
    }

    return <div className="hero-image-text">{this.props.productName}</div>;
  };

  // renderBenefits = () => {
  //   let benefits = null;

  //   if (this.props.route.extraPlan) {
  //     benefits = this.props.extraBenefits
  //       ? this.props.extraBenefits.get(this.props.route.extraPlan)
  //       : null;
  //   } else {
  //     benefits = this.props.siteCheckout
  //       ? this.props.siteCheckout.get("benefits")
  //       : null;
  //   }

  //   if (benefits && benefits.size > 0) {
  //     const benefitsJSX = benefits.map((benefit, idx) => {
  //       return (
  //         <div className="benefit-row" key={idx}>
  //           <div className="benefit-checkmark" />
  //           <div className="benefit-text">{benefit}</div>
  //         </div>
  //       );
  //     });

  //     return (
  //       <div className="benefits-box benefits-box--payments">
  //         <div className="benefits-header"> What users get </div>
  //         {benefitsJSX}
  //       </div>
  //     );
  //   } else {
  //     return null;
  //   }
  // };

  renderHeroSection = () => {
    const heroImgUrl = this.props.siteCheckout
      ? this.props.siteCheckout.get("heroImage")
      : null;

    const deepLink = this.props.siteCheckout
      ? this.props.siteCheckout.get("deepLink")
      : null;

    return (
      <div
        className="hero-image"
        style={{
          backgroundImage: `url(${heroImgUrl})`,
        }}
      >
        <div className="hero-image-overlay" />
        {this.renderHeroText()}
        {deepLink ? (
          <div className="app-stores-row">
            <img
              src={require("../../images/appStore.svg")}
              className="app-store-img"
              onClick={this.onClickApp}
            />
            <img
              src={require("../../images/googlePlay.svg")}
              className="google-play-img"
              onClick={this.onClickApp}
            />
          </div>
        ) : null}
      </div>
    );
  };

  renderHeader = () => {
    let sectionsClass = "navbar-section";
    if (this.props.route.navBarColor === "trybe-black") {
      sectionsClass = "navbar-section-black";
    }

    return (
      <div className={sectionsClass}>
        <div className="navbar-content">
          <div
            className="logo-container"
            onClick={() => {
              window.location.href = "https://trybe.fit";
            }}
          >
            <img
              className="logo-img"
              src={require("../../images/trybe-logo-white.svg")}
            />
            <div className="logo-text">TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedPlanIdx,
      activeSection,
      benefitsShowing,
      isAuthed,
      emailError,
      giftEmailError,
    } = this.state;

    return (
      <div className="coach-checkout-container">
        {this.renderHeader()}

        {this.state.shouldSurvey ? (
          this.renderSurvey()
        ) : (
          <div className="main-body-container">
            {this.renderHeroSection()}
            <div className="main-body">
              <div className="payments-flow">
                {this.renderLogo()}
                <div className="section-container">
                  <div
                    className={
                      activeSection === 0
                        ? "section-header-active"
                        : "section-header-inactive"
                    }
                  >
                    <div
                      className={
                        selectedPlanIdx || selectedPlanIdx === 0
                          ? "section-checkmark"
                          : null
                      }
                    />
                    {"1. Select plan to gift"}
                  </div>
                  <div
                    className={
                      activeSection === 0
                        ? "plan-selection-active"
                        : "plan-selection-inactive"
                    }
                  >
                    <div className="plan-radio-options">
                      {!(selectedPlanIdx || selectedPlanIdx === 0)
                        ? this.renderPlanOptions()
                        : this.renderSelectedPlan()}
                    </div>
                  </div>
                  {/* {this.renderBenefits()} */}
                </div>

                {
                  <div
                    className={
                      benefitsShowing
                        ? "section-container section-container-adj-top"
                        : "section-container"
                    }
                  >
                    <div
                      className={
                        activeSection === 1
                          ? "section-header-active"
                          : "section-header-inactive"
                      }
                    >
                      <div className={isAuthed ? "section-checkmark" : null} />
                      {"2. Enter Information"}
                    </div>
                    <div
                      className={
                        activeSection === 1
                          ? "create-account-active"
                          : "create-account-inactive"
                      }
                      style={{ paddingTop: 18, paddingBottom: 18 }}
                    >
                      {this.renderAccountSection()}
                      {emailError || giftEmailError
                        ? this.renderErrors()
                        : null}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "85%",
                        marginTop: 6,
                        marginBottom: 6,
                        fontWeight: 500,
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div style={{ fontSize: 14, width: "85%", marginTop: 6 }}>
                        {
                          "A gift code will be emailed to the recipient at your chosen time. Your email will be used to let them know who the gift is from."
                        }
                      </div>
                      <div style={{ fontSize: 14, width: "85%", marginTop: 6 }}>
                        {
                          "You will receive a copy of the gift card immediately in case you also want to give the gift in person."
                        }
                      </div>
                    </div>
                  </div>
                }

                <div className="section-container section-container-last">
                  <div
                    className={
                      activeSection === 2
                        ? "section-header-active"
                        : "section-header-inactive"
                    }
                  >
                    {"3. Enter billing info"}
                  </div>
                  <div className="payment-method">
                    {this.renderPayButton()}
                    {this.renderPaymentError()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  getCheckoutSuccessUrl = () => {
    let urlParams = window.location.search.substring(1);

    if (urlParams) {
      urlParams += "&";
    }

    urlParams += `coachOrgId=${this.state.coachOrgId}`;

    const domain =
      config.dbEnv === "dev"
        ? "http://localhost:8000/webpack-dev-server"
        : "https://trybe.do";

    return `${domain}/gift_success?${urlParams}`;
  };

  /*
  Returns valid PROMO object to render using the following order of operations:
  1. Check for coupon in URL
  2. Return first coupon in Promo Array to match first valid coupon in URL params. Must be active based on start/expire dates
  3. Else return first autoApplied promo that is active based on start/expire dates
  For backwards compatibility, checks if promos is an array using promo.get('stripeCouponId') which will assume its not an array of promos but a single promo
  */
  findValidPromo = (plan, unixBuffer = 0) => {
    return false //tempp dont allow any promos

    if (!plan) {
      return false;
    }

    const promos = plan.get("promo");
    if (!promos) {
      return false;
    }

    //Generates a comma separated string of couponIds in URL
    const couponIds = getURLVal("coupon");
    let coupons = null;
    if (Array.isArray(couponIds)) {
      coupons = couponIds.join();
    } else {
      coupons = couponIds;
    }

    //Handles all backwards compatibility checks for when "promo" is not an array
    const isSinglePromo = promos.get("stripeCouponId") ? true : false;
    if (isSinglePromo) {
      const now = new Date().getTime();
      const expiration = promos.get("expiration");
      const bufferedExpiration = expiration + unixBuffer;
      const startDate = promos.get("startDate");

      const dateValid = now > startDate && now < bufferedExpiration;
      const isAutoApplied = promos.get("isAutoApplied");
      const isInCoupons =
        coupons && coupons.search(promos.get("stripeCouponId")) >= 0;

      if (dateValid) {
        if (isAutoApplied || isInCoupons) {
          return promos;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    //Checks for valid Coupons in URL first
    if (coupons) {
      const couponPromos = promos.filter((promo, idx) => {
        const now = new Date().getTime();
        const expiration = promo.get("expiration");
        const bufferedExpiration = expiration + unixBuffer;
        const startDate = promo.get("startDate");

        const dateValid = now > startDate && now < bufferedExpiration;
        const urlMatch = coupons.search(promo.get("stripeCouponId")) >= 0;
        const valid = dateValid && urlMatch;

        return valid;
      });

      if (!couponPromos.isEmpty()) {
        return couponPromos.first();
      }
    }

    //Checks for Coupons autoapplied next
    const autoAppliedPromos = promos.filter((promo, idx) => {
      const now = new Date().getTime();
      const expiration = promo.get("expiration");
      const bufferedExpiration = expiration + unixBuffer;
      const startDate = promo.get("startDate");

      const dateValid = now > startDate && now < bufferedExpiration;
      const isAutoApplied = promo.get("isAutoApplied");
      const valid = dateValid && isAutoApplied;

      return valid;
    });

    if (!autoAppliedPromos.isEmpty()) {
      return autoAppliedPromos.first();
    }

    return false;
  };
}

export default CoachGiftCheckout;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/CoachGiftCheckout.js